<div class="bg-shui-base-2 p-4 rounded-md border border-shui-base-1">
    <div class="flex flex-col gap-3">
        <div class="flex items-center justify-between">
            <h3 class="text-base font-semibold text-shui-text-strong m-0">{{ entry().userName }}</h3>
            <sh-icon icon="cancel" button size="xs" class="cursor-pointer" (click)="onCancel()"></sh-icon>
        </div>
        <div class="flex gap-2">
            <div class="flex-1">
                <sh-text size="body-2" color="secondary">{{
                    'common.out-of-office.overview.leave-date' | translate
                }}</sh-text>
                <sh-text size="body-1">{{ entry().dateRange }}</sh-text>
            </div>
            <div class="flex-1">
                <sh-text size="body-2" color="secondary">{{
                    'common.out-of-office.overview.days-off' | translate
                }}</sh-text>
                <sh-text size="body-1">{{ entry().daysOff }}</sh-text>
            </div>
        </div>
        <div>
            <sh-text size="body-2" color="secondary">{{
                'common.out-of-office.overview.coverage' | translate
            }}</sh-text>
            <sh-text size="body-1">{{ entry().coverageName }}</sh-text>
        </div>
        @if (isAdmin()) {
            <div class="flex items-center justify-end gap-2 pt-1">
                <sh-button
                    [label]="'common.general.delete' | translate"
                    color="tertiary"
                    size="max-content"
                    [disabled]="isDeleting()"
                    [icon]="isDeleting() ? 'loading' : null"
                    icon-position="end"
                    (click)="onDelete()"
                ></sh-button>
            </div>
        }
    </div>
</div>
